<template>
    <div>
        <ValidationObserver slim ref="form">
            <form @submit.prevent="onSubmit">
                <p>
                    <label for="pwd1">Mot de passe</label>
                    <ValidationProvider slim name="pwd1" :rules="{ required: true, regex: password_regex_global, confirmed: 'confirmation' }" v-slot="{ classes, errors }">
                        <input type="password" name="pwd" id="pwd1" :class="classes" v-model="user.pass" />
                        <span class="error-txt">{{ errors[0] }}</span>
                    </ValidationProvider>
                </p>

                <p>
                    <label for="pwd2">Confirmation du mot de passe</label>
                    <ValidationProvider slim name="pwd2" :rules="{ required: true, regex: password_regex_global }" v-slot="{ classes, errors }" vid="confirmation">
                        <input type="password" name="pwd" id="pwd2" :class="classes" v-model="user.pass2" />
                        <span class="error-txt">{{ errors[0] }}</span>
                    </ValidationProvider>
                </p>

                <input type="submit" value="Se connecter" />

            </form>
        </ValidationObserver>

        <p class="success-txt" v-if="success">{{ success }}</p>
    </div>
</template>

<script>
import Password from "../../mixins/Password";
import User from "../../services/User";

export default {
    props: ['url_pro_homepage'],
    mixins: [Password],
    data() {
        return {
            loader: false,
            success: null,
            user: {}
        }
    },
    watch: {
        'user.pass'(after, before) {
            this.checkRulesPassword(after);
        }
    },
    mounted() {
        this.getUser();
    },
    methods: {
        getUser() {
            this.loader = true;
            User.me().then((response) => {
                this.user = response;
            }).catch((error) => {

            }).finally(() => {
                this.loader = false;
            });
        },
        onSubmit() {
            this.$refs.form.validate().then(success => {
                if (!success) {
                    return;
                }

                this.updateUser();
            });
        },
        updateUser() {
            if(this.loader)
                return;

            this.loader = true;
            User.update(this.user).then((response) => {
                this.success = 'Vos informations ont bien été enregistrées. Vous allez être rediriger vers la page d\'accueil PRO dans quelques secondes...';
                setTimeout(() => {
                    this.success = null;
                    window.location.href = this.url_pro_homepage;
                }, 3000);
                this.$emit('refreshUser', response.user);
                this.is_editable = false;
            }).catch((error) => {
                this.$refs.form.setErrors(error.response.data.errors);
            }).finally(() => {
                this.loader = false;
            });
        },
    }
}
</script>
